import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  setVisible,
  setUnlock,
  setImage,
  setDescription,
  setTitle,
  setHotLevel,
  setNumber,
} from "../../../store/slices/kamasutra";
import { convertLanguageToField } from "../../../utils/functions";
import axios from "../../../services/axios";
import useAuth from "../../../hooks/useAuth";
import { useNavigate } from "react-router";

import styles from "./kamaListCard.module.css";

export default function KamaListCard({
  unlocked,
  number,
  item,
  className,
  borderSize,
}) {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const { i18n } = useTranslation();
  const [animation, setAnimation] = useState(false);
  const { user, setUser } = useAuth();

  useEffect(() => {
    if (unlocked === 1) {
      const interval = setInterval(() => {
        setAnimation(true);
        setTimeout(() => {
          setAnimation(false);
        }, 1000);
      }, 5000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [unlocked]);

  const handleClick = () => {
    switch (unlocked) {
      case 1:
        axios
          .post(`user/unlockKama`, { id_usuario: user.id_usuario })
          .then((response) => {
            const { data } = response;
            setUser(data);
          });
        // Modal desbloqueio
        dispatch(setUnlock(true));
        dispatch(setImage(item.img_carta));
        dispatch(setHotLevel(item.nivel));
        dispatch(setNumber(number));
        break;
      case 2:
        // Modal detalhes
        dispatch(setVisible(true));
        dispatch(setImage(item.img_carta));
        dispatch(setHotLevel(item.nivel));
        dispatch(setNumber(number));
        const field1 = convertLanguageToField(i18n.language, "desafio");
        const field2 = convertLanguageToField(i18n.language, "title");

        dispatch(setDescription(item[field1] || ""));
        dispatch(setTitle(item[field2] || ""));
        break;
      default:
        navigation("/premium");
        break;
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`${styles.card} ${animation ? styles.animate : ""} 
        ${!unlocked ? "opacity-40" : ""} ${className || ""}
    `}
    >
      <div
        className={`${styles.cardBody} ${
          unlocked === 2 ? styles.cardBodyUnlocked : ""
        }`}
      >
        <div
          className={styles.cardContent}
          style={{
            borderImageSource: `url(${
              !unlocked
                ? require("../../../assets/images/games/kamasutra/borda-branca.png")
                : unlocked === 1
                ? require("../../../assets/images/games/kamasutra/borda-active.png")
                : require("../../../assets/images/games/kamasutra/borda.png")
            })`,
            borderImageWidth: borderSize ? `${borderSize}px` : undefined,
          }}
        >
          {unlocked === 2 ? (
            <div className="flex justify-center items-center h-full w-full">
              <img className={styles.cardImage} src={item.img_carta} alt="" />
            </div>
          ) : (
            <div className="flex justify-center items-center h-full w-full">
              <h2
                className={`${styles.number} ${
                  unlocked === 1 ? styles.active : ""
                }`}
              >
                {number}
              </h2>
            </div>
          )}
        </div>
      </div>
    </button>
  );
}
